import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=275bfbb7&scoped=true&"
import script from "./userManagement.vue?vue&type=script&lang=js&"
export * from "./userManagement.vue?vue&type=script&lang=js&"
import style0 from "./userManagement.vue?vue&type=style&index=0&id=275bfbb7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275bfbb7",
  null
  
)

export default component.exports